<div #datepickerField tabindex="0"
  [ngClass]="['mp-date-picker', size, customClasses, outlinedColor ?? 'primary', outlinedStyle ?? 'solid']"
  [class.disabled]="disabled"
  [class.readonly]="isReadOnly"
  [class.outlined]="outlined"
  [class.opened]="displayCalendar()"
  [class.invalid]="!isValid()"
  [class.without-value]="!startDateValue">
  @if (label && !startDateValue && !startTime) {
    <label class="mp-date-picker-label"
    [innerHTML]="label | translate"></label>
  }
  <div class="mp-date-picker-wrapper">
    <div (click)="openDatepicker()" (keydown.enter)="openDatepicker()" tabindex="0">
      <i #calendarIcon class="far fa-calendar-day {{outlinedColor ?? 'primary'}}"></i>
    </div>

    @if ((!startTime && !endTime)) {
      <div class="mp-date-inputs">
        <input #dateInput class="mp-date-input" [readonly]="disabled || isReadOnly"
          [(ngModel)]="startDateValue" [ngModelOptions]="{standalone: true}" (blur)="onDateBlur()">
          @if (endDateValue) {
            <span>-</span>
            <input #dateEndInput class="mp-date-input" [readonly]="disabled"
              [(ngModel)]="endDateValue" [ngModelOptions]="{standalone: true}" (blur)="onEndDateBlur()">
            }
          </div>
        }

        @if ((startTime || endTime)) {
          <div class="mp-date-plus-hours">
            <span class="mp-date-value">
              {{ startDateValue }}
              @if (endDateValue) {
                <span>-</span>
                {{ endDateValue }}
              }
            </span>
            <span class="mp-hours-value">{{ timeLabel }}</span>
          </div>
        }
      </div>
    </div>

    @if (displayCalendar()) {
      <app-mp-calendar
        [anchor]="datepickerFieldElementRef"
        [startDay]="+startDay"
        [endDay]="+endDay"
        [startMonth]="+this.startMonth - 1"
        [endMonth]="+this.endMonth - 1"
        [startYear]="+this.startYear"
        [endYear]="+this.endYear"
        [datePicked]="datePicked.bind(this)"
        [resetSelection]="resetDatepicker.bind(this)"
        [resetStartTime]="resetStartTime.bind(this)"
        [resetEndTime]="resetEndTime.bind(this)"
        [dateIntervalAllowed]="dateIntervalAllowed"
        [timeIntervalAllowed]="timeIntervalAllowed"
        [startTime]="startTime"
        [endTime]="endTime"
        [minDate]="minDate"
        [onlyBusinessDays]="onlyBusinessDays">
      </app-mp-calendar>
    }
